import { FetchPerlgemRPCParams } from '../types';

export async function fetchPerlgemRPC<T>({
  method,
  params = [{}],
  id = 1,
}: FetchPerlgemRPCParams): Promise<T | undefined> {
  const url = `/rpc/jsonrpc.tmpl?dbgmethod=${method}`;
  const postObj = [
    {
      method,
      id,
      params,
    },
  ];
  const formData = new URLSearchParams();
  formData.append('JSONRPC', JSON.stringify(postObj));

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Source-Page': window?.location?.href
      },
    });
    const responseData = await response.json();

    return responseData[0]?.result?.value;
  } catch (e) {
    // Intentionally ignoring errors for this RPC call
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isInViewport(element: any) {
  if (element) {
    const specs = element.getBoundingClientRect();
    return (
      specs.top >= 0 &&
      specs.left >= 0 &&
      specs.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      specs.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}

export function truncateToTwoDecimalPlaces(str: string) {
  let num = parseFloat(str);
  num = Math.trunc(num * 100) / 100;
  return num.toFixed(2);
}

export function formatCurrencyToTwoDecimals(amount: number): number {
  return parseFloat((amount / 100).toFixed(2));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function convertArrayToTwoDecimalPlaces(arr: any[]) {
  return arr.map(truncateToTwoDecimalPlaces);
}

export function getCookie(name: string): string {
  return (
    document.cookie
      .split('; ')
      .find((item: string) => item.startsWith(`${name}=`))
      ?.split('=')[1] || ''
  );
}

// TODO: legacy support - is this needed? verify where this is used (probably tealium)
window.isInViewport = isInViewport;
